import React from 'react';
import { motion } from 'framer-motion';
export function Founders() {
  const team = [{
    name: 'Aaron Leon',
    role: 'CTO',
    bio: "Tech lead at Amazon One Medical, led 50+ engineers on the in-house EHR and AI tools serving 1M+ patients. Built Amazon Care's data platform from zero to nationwide scale."
  }, {
    name: 'Prabha Dublish',
    role: 'CEO',
    bio: 'First product hire at Grow Therapy (Sequoia-backed, scaled from $90M to $3B valuation). Launched AI features at Grow. Former Meta PM/PMM.'
  }];
  return <section id="team" className="py-24 bg-hubble-card/20 relative z-10 border-t border-hubble-border/50" data-id="element-25">
      <div className="max-w-7xl mx-auto px-6" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <span className="text-hubble-accent text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-28">
            TEAM
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-text" data-id="element-29">
            Built by people who've done this before.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-30">
          {team.map((person, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center p-8 rounded-2xl border border-hubble-border bg-hubble-card" data-id="element-31">
              <div className="w-24 h-24 rounded-full bg-hubble-bg border border-hubble-border mb-6 flex items-center justify-center overflow-hidden" data-id="element-32">
                <div className="w-full h-full flex items-center justify-center font-heading text-2xl text-hubble-body" data-id="element-33">
                  {person.name.charAt(0)}
                </div>
              </div>

              <h3 className="font-heading text-2xl font-medium text-hubble-text mb-2" data-id="element-34">
                {person.name}
              </h3>
              <div className="text-hubble-accent font-body text-sm mb-4" data-id="element-35">
                {person.role}
              </div>
              <p className="font-body text-[16px] text-hubble-body leading-[1.6]" data-id="element-36">
                {person.bio}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}